module.exports = __webpack_public_path__ + "static/img/securitybg4.438abf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/securitybg4.jpg
// module id = Cmr3
// module chunks = 1